<template>
  <div class="Tabs">
    <TabsHead :active.sync="active" :tabs="slots" />
    <div class="body">
      <slot :name="selectedSlot" />
    </div>
  </div>
</template>

<script>
import Tabable from 'mixins/Tabable'
import TabsHead from 'components/TabsHead'

export default {
  mixins: [Tabable],
  components: { TabsHead },
  computed: {
    selectedSlot() {
      const [selected] = this.slots.filter(slot => this.active === slot)
      return selected
    },
  },
}
</script>

<style lang="scss">
.Tabs {
  // ---------- sizes -----------
  // &.lg {}

  // ---------- styles ----------
  &.center {
    .TabsHead {
      text-align: center;
    }
  }
}
</style>
